import * as React from 'react'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { BaseCircleButton, styles } from '@components/Buttons/BaseCircleButton'
import * as Colors from '@themes/Colors'

export const PlusButton = ({ ...rest }) => {
  return (
    <BaseCircleButton
      buttonStyles={[styles.button, styles.buttonAltPrimary]}
      {...rest}
    >
      <FontAwesomeIcon
        icon={findIconDefinition({ prefix: 'fal', iconName: 'plus' })}
        color={Colors.white}
      />
    </BaseCircleButton>
  )
}
